import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el Ultrapack después de comprar?',
    a: 'Inmediatamente después del pago recibís un email con el link de descarga. En menos de 5 minutos tenés todo el material en tu dispositivo, listo para usar desde hoy mismo.'
  }, {
    q: '¿Es editable? ¿Puedo modificarlo?',
    a: 'El material está en formato PDF listo para usar. Podés completar las planillas digitalmente o imprimirlas. Los modelos de informes están diseñados para personalizar con los datos de cada paciente en minutos.'
  }, {
    q: '¿Sirve para todas las edades y perfiles clínicos?',
    a: 'Sí. El sistema cubre pediatría (desde estimulación temprana hasta adolescencia), adultos en rehabilitación y adultos mayores. Cada tomo especifica el rango de edad y el perfil clínico para el que fue diseñado.'
  }, {
    q: '¿Los 6 bonos están en las dos ofertas?',
    a: 'Sí. Los 6 bonos estratégicos están incluidos en las dos opciones sin costo adicional. La diferencia entre las dos ofertas es que la opción completa incluye además el Método Consultorio Élite™.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 px-4 bg-dark-card/30 pt-[15px] pb-[15px]" data-id="element-123">
      <div className="max-w-2xl mx-auto" data-id="element-124">
        <h2 className="text-2xl md:text-3xl font-black text-center mb-6" data-id="element-125">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2" data-id="element-126">
          {faqs.map((faq, i) => <div key={i} className="bg-dark border border-dark-border rounded-xl overflow-hidden" data-id="element-127">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-4 text-left focus:outline-none" data-id="element-128">
                <span className="font-bold text-sm" data-id="element-129">{faq.q}</span>
                <ChevronDown className={`w-4 h-4 text-brand transition-transform duration-300 flex-shrink-0 ml-2 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-130" />
              </button>
              <AnimatePresence data-id="element-131">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-132">
                    <div className="px-4 pb-4 text-gray-400 text-sm border-t border-dark-border/50" data-id="element-133">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}